import { sm2, sm3, sm4 } from 'sm-crypto' // 引用国密
import store from '@/store'
const CIPHER_MODE = 1, // 密文排列方式0-C1C2C3；1-C1C3C2(国密标准)
  PUBLIC_KEY = '042ca56789cb37a2ca873973dfe76c604961fe3ef97662f80310bd0fd81f9462f23e9012a96332eb5763407fa7ea1623cf776d020db9b79f8d0be8fc0430d77532' // 公钥和密文前加04

// 处理请求体（参数加密）
export function createBody(body) {
  // console.log('request body, before encrypt:', JSON.stringify(body))
  let sm2Body = sm2.doEncrypt(JSON.stringify(body), PUBLIC_KEY, CIPHER_MODE).toUpperCase()
  // console.log('request body, after encrypt:', '04' + sm2Body)
  return '04' + sm2Body
}

// 返回解密
export function decryptResponse(res) {
  // res = res ? sm2.doDecrypt(res.slice(2), PRIVATE_KEY, CIPHER_MODE) : null
  res = res ? decryptSm4(res, store.getters.getEncryptKey) : null
  console.log('decrypt data:', res)
  return res
}
// 本地测试生成sign
export function createSign(str) {
  // console.log('sign before:', str)
  return sm3(str)
}

const stringToHex = (str) => {
  return Buffer.from(str, 'utf-8').toString('hex')
}

export const decryptSm4 = (encryptedData, k) => {
  const key = stringToHex(k)
  try {
    const encryptedBytes = Uint8Array.from(atob(encryptedData), c => c.charCodeAt(0))

    // 执行 SM4 解密
    const decryptedBytes = sm4.decrypt(encryptedBytes, key, {
      padding: 'pkcs7'
    })
    // 将解密后的字节数组转换为 UTF-8 字符串
    return decryptedBytes.replace(/[^\x20-\x7E\u4E00-\u9FFF]/g, '')
  } catch (e) {
    console.log(e)
  }
  // 将 Base64 转换为 Uint8Array
}

export { CIPHER_MODE, PUBLIC_KEY }



//////////////////
// WEBPACK FOOTER
// ./static/js/signValidate.js
// module id = z1fX
// module chunks = 16